<template>
  <Content
    class="col-span-full"
    :title="$route.name"
    :router="{
      name: 'VEHICLE_SERVICE_LIST',
    }"
  >
    <el-form
      status-icon
      :model="ruleForms[0]"
      :rules="rules"
      label-position="top"
      ref="ruleForm"
      label-width="120px"
      class="demo-ruleForm flex service__container flex-col"
    >
      <div
        v-for="(formEntry, index) in ruleForms"
        :key="index"
        class="form-entry grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-5"
      >
        <VehicleSelect
          v-if="index === 0"
          prop="company_vehicle"
          :model="formEntry.company_vehicle"
          @update="handleOnSelectVehcile($event, index)"
          :disabled="index > 0 || formEntry.disabled"
        />
        <el-form-item v-if="index === 0" :label="$t('DATE')" prop="date">
          <date-picker
            :disabled="index > 0 || formEntry.disabled"
            class="el-input__inner"
            v-model="formEntry.date"
            :locale="$i18n.locale"
            format="jYYYY-jMM-jDD"
            clearable
          />
        </el-form-item>
        <el-form-item
          v-if="index === 0"
          :label="$t('DISTANCE_TRAVEL')"
          prop="odometer"
        >
          <el-input
            type="text"
            :disabled="index > 0 || formEntry.disabled"
            v-model="formEntry.odometer"
            @input="
              formEntry.odometer = formatOdometerInput(formEntry.odometer)
            "
            autocomplete="off"
          ></el-input>
        </el-form-item>

        <el-form-item
          :label="$t('SERVICE')"
          prop="service"
          v-loading="serviceLoading"
          element-loading-spinner="el-icon-loading"
        >
          <el-select
            :disabled="formEntry.disabled"
            v-model="formEntry.service"
            clearable
            filterable
            :no-data-text="$t('NO_RESULT')"
            :placeholder="$t('SELECT_PLACEHOLDER')"
          >
            <el-option
              v-for="item in serviceList"
              :key="item.id"
              :label="$i18n.locale == 'fa' ? item.fa_title : item.en_title"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <PriceInput
          label="PRICE"
          :loading="loading"
          prop="price"
          :model="formEntry.price"
          @update="formEntry.price = $event"
          :disabled="formEntry.disabled"
        />

        <el-form-item
          :label="`${$t('APPROVAL_USERS')}`"
          prop="approvers"
          v-loading="usersListLoading"
          element-loading-spinner="el-icon-loading"
        >
          <el-select
            :disabled="formEntry.disabled"
            v-model="formEntry.approvers"
            clearable
            multiple
            :collapse-tags="!formEntry.disabled"
            filterable
            :placeholder="$t('SELECT_PLACEHOLDER')"
          >
            <el-option
              v-for="item in userList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <div class="col-span-full grid gap-4 xl:grid-cols-2">
          <div>
            <div>
              <Subtitle
                :title="$t('SERVICE_SETTING')"
                class="col-span-full my-2"
              />

              <Notice class="col-span-full mb-8 border-0 text-xs">
                {{ $t('NextServiceInfo') }}
              </Notice>
            </div>
            <div class="grid xl:grid-cols-2 gap-4">
              <el-form-item :label="$t('DAY_INTERVAL')" prop="day_interval">
                <el-input
                  type="text"
                  :disabled="formEntry.disabled"
                  v-model="formEntry.day_interval"
                  @input="
                    formEntry.day_interval = toEnglish(formEntry.day_interval)
                    validateFields('day_interval')
                  "
                  autocomplete="off"
                ></el-input>
              </el-form-item>
              <el-form-item :label="$t('DAY_THRESHOLD')" prop="day_threshold">
                <el-input
                  type="text"
                  :disabled="formEntry.disabled"
                  v-model="formEntry.day_threshold"
                  @input="
                    formEntry.day_threshold = toEnglish(formEntry.day_threshold)
                    validateFields('day_threshold')
                  "
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="flex flex-col justify-between">
            <div>
              <Subtitle
                :title="$t('NOTIFICATION_SETTING')"
                class="col-span-full my-2"
              />
              <Notice class="col-span-full mb-8 border-0 text-xs">
                {{ $t('SetReminderConditions') }}
              </Notice>
            </div>
            <div class="grid xl:grid-cols-2 gap-4">
              <el-form-item :label="$t('METER_INTERVAL')" prop="meter_interval">
                <el-input
                  type="text"
                  :disabled="formEntry.disabled"
                  v-model="formEntry.meter_interval"
                  @input="
                    formEntry.meter_interval = formatMeterInput(
                      formEntry.meter_interval
                    )
                    validateFields('meter_interval')
                  "
                  autocomplete="off"
                ></el-input>
              </el-form-item>

              <el-form-item
                :label="$t('METER_THRESHOLD')"
                prop="meter_threshold"
              >
                <el-input
                  type="text"
                  :disabled="formEntry.disabled"
                  v-model="formEntry.meter_threshold"
                  @input="
                    formEntry.meter_threshold = formatMeterInput(
                      formEntry.meter_threshold
                    )
                    validateFields('meter_threshold')
                  "
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </div>
          </div>
        </div>

        <el-form-item
          class="col-span-full"
          :label="$t('description')"
          prop="description"
        >
          <el-input
            :disabled="formEntry.disabled"
            type="textarea"
            v-model="formEntry.description"
          ></el-input>
        </el-form-item>

        <!-- Attachments Section -->
        <div class="col-span-full">
          <Subtitle :title="$t('ATTACHMENTS')" class="col-span-full my-2" />

          <!-- Existing Attachments -->
          <div
            v-if="formEntry.attachments && formEntry.attachments.length > 0"
            class="mb-4"
          >
            <div
              v-for="(attachment, attIndex) in formEntry.attachments"
              :key="attIndex"
              class="
                flex
                items-center
                justify-between
                p-3
                bg-gray-50
                rounded-lg
                mb-2
              "
            >
              <div class="flex items-center">
                <i class="el-icon-document mr-2"></i>
                <span class="text-sm">
                  {{ attachment.title || 'Untitled' }}
                </span>
              </div>
              <div class="flex items-center gap-2">
                <el-button
                  size="mini"
                  type="primary"
                  icon="el-icon-download"
                  v-if="attachment.id"
                  @click="downloadAttachment(attachment.id)"
                  :loading="downloadingAttachments[attachment.id]"
                >
                  {{ $t('DOWNLOAD') }}
                </el-button>
                <el-button
                  v-if="!formEntry.disabled"
                  size="mini"
                  type="danger"
                  icon="el-icon-delete"
                  @click="removeAttachment(attIndex, index)"
                >
                  {{ $t('DELETE') }}
                </el-button>
              </div>
            </div>
          </div>

          <!-- Add New Attachment -->
          <div
            v-if="!formEntry.disabled"
            class="border-2 border-dashed border-gray-300 rounded-lg p-4"
          >
            <div class="grid grid-cols-1 md:grid-cols-4 gap-4">
              <el-form-item
                :label="$t('ATTACHMENT_TITLE')"
                prop="newAttachmentTitle"
              >
                <el-input
                  v-model="formEntry.newAttachmentTitle"
                  :placeholder="$t('ENTER_ATTACHMENT_TITLE')"
                ></el-input>
              </el-form-item>
              <el-form-item prop="newAttachmentFile">
                <div class="file-upload-container">
                  <input
                    type="file"
                    :id="`file-input-${index}`"
                    @change="handleFileInputChange($event, index)"
                    accept="*/*"
                    style="display: none"
                  />
                  <label :for="`file-input-${index}`" class="file-upload-label">
                    <i class="el-icon-upload"></i>
                    <span class="whitespace-nowrap text-xs">
                      {{
                        formEntry.selectedFile
                          ? formEntry.selectedFile.name
                          : $t('SELECT_FILE')
                      }}
                    </span>
                    <i
                      @click="clearFile(index)"
                      v-if="formEntry.selectedFile"
                      class="
                        el-icon-close
                        bg-red-50
                        rounded-md
                        text-red-500
                        cursor-pointer
                        p-1
                      "
                    ></i>
                  </label>
                </div>
              </el-form-item>
              <div class="flex justify-end md:col-start-4 items-start">
                <el-button
                  type="primary"
                  @click="addAttachment(index)"
                  :loading="formEntry.uploadingAttachment"
                >
                  <i class="el-icon-plus mr-1"></i>
                  {{ $t('ADD_ATTACHMENT') }}
                </el-button>
              </div>
            </div>
          </div>
        </div>
        <div
          class="flex items-start justify-end lg:col-span-full gap-2"
          v-if="addable"
        >
          <div
            v-if="ruleForms.length === index + 1 && !service"
            class="xl:col-span-2 justify-end flex items-start"
          >
            <el-button type="primary" rounded @click="addEntry">
              <i class="el-icon-plus font-medium"></i>
            </el-button>
          </div>
          <el-button
            type="danger"
            icon="el-icon-minus"
            rounded
            @click="removeEntry"
            v-if="ruleForms.length > 1"
          ></el-button>
        </div>
      </div>

      <FormConfirmation
        v-show="!ruleForms[0].disabled"
        @resetForm="resetForm('ruleForm')"
        @submitForm="submitForm('ruleForm')"
        :edit="null"
        :loading="submitLoading"
      />
    </el-form>
  </Content>
</template>
<script>
import { resetForm } from '@/mixins/resetForm'
import { jalaliToGregorian } from '@/mixins/jalaliToGregorian'
import { reverseCurrency } from '@/mixins/reverseCurrency'
import FormConfirmation from '@/components/elements/formConfirmation.vue'
import VehicleSelect from '@/components/elements/vehiclesSelect.vue'
import Notice from '@/components/elements/notice'
import { carsListSummary, getACar } from '@/api/cars'
import { serviceNameList, addService, editService } from '@/api/services'
import PriceInput from '@/components/elements/priceInput.vue'
import { currency } from '@/mixins/currency'
import { usersListSummary } from '@/api/acl'
import { axiosFactory } from '@/configs/axios'

export default {
  mixins: [resetForm, jalaliToGregorian, reverseCurrency, currency],
  props: {
    service: {
      type: Object,
      required: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    FormConfirmation,
    Notice,
    VehicleSelect,
    PriceInput,
  },
  data() {
    var priceCheck = (rule, value, callback) => {
      value = this.reverseCurrency(value)
      if (value == '') {
        callback(
          new Error(
            this.$i18n.t('COST_LESS_THAN', {
              type: '2',
            })
          )
        )
      }
      if (this.reverseCurrency(value) <= 2000000000) {
        callback()
      } else {
        callback(
          new Error(
            this.$i18n.t('COST_LESS_THAN', {
              type: '2',
            })
          )
        )
      }
    }
    var checkSelect = (rule, value, callback) => {
      if (value != '') {
        callback()
      } else {
        callback(new Error(rule.message))
      }
    }
    var validateMeterInterval = (rule, value, callback) => {
      const formEntry = this.ruleForms.find(
        (form) => form.meter_interval === value
      )
      if (value && !formEntry.meter_threshold) {
        callback(
          new Error(
            this.$i18n.t('REQUIRED_FIELD', {
              type: this.$i18n.t('METER_THRESHOLD'),
            })
          )
        )
      } else {
        callback()
      }
    }

    var validateMeterThreshold = (rule, value, callback) => {
      const formEntry = this.ruleForms.find(
        (form) => form.meter_threshold === value
      )
      if (value && !formEntry.meter_interval) {
        callback(
          new Error(
            this.$i18n.t('REQUIRED_FIELD', {
              type: this.$i18n.t('METER_INTERVAL'),
            })
          )
        )
      } else {
        callback()
      }
    }

    var validateDayInterval = (rule, value, callback) => {
      const formEntry = this.ruleForms.find(
        (form) => form.day_interval === value
      )
      if (value && !formEntry.day_threshold) {
        callback(
          new Error(
            this.$i18n.t('REQUIRED_FIELD', {
              type: this.$i18n.t('DAY_THRESHOLD'),
            })
          )
        )
      } else {
        callback()
      }
    }

    var validateDayThreshold = (rule, value, callback) => {
      const formEntry = this.ruleForms.find(
        (form) => form.day_threshold === value
      )
      if (value && !formEntry.day_interval) {
        callback(
          new Error(
            this.$i18n.t('REQUIRED_FIELD', {
              type: this.$i18n.t('DAY_INTERVAL'),
            })
          )
        )
      } else {
        callback()
      }
    }
    return {
      serviceList: [],
      list: [],
      addable: true,

      serviceLoading: false,
      serviceTypeLoading: false,
      carsLoading: false,
      realprice: 0,
      submitLoading: false,
      userList: [
        {
          label: '',
          value: '',
        },
      ],
      usersListLoading: true,
      downloadingAttachments: {},
      ruleForms: [
        {
          approvers: [],
          price: '',
          service: '',
          company_vehicle: '',
          date: '',
          disabled: false,
          meter_threshold: null,
          day_threshold: 7,
          meter_interval: null,
          day_interval: 30,
          odometer: 0,
          attachments: [],
          newAttachmentTitle: '',
          selectedFile: null,
          uploadingAttachment: false,
        },
      ],

      rules: {
        service: [
          {
            required: true,
            message: this.$i18n.t('REQUIRED_CHOOSE', {
              type: this.$i18n.t('SERVICE'),
            }),
            trigger: 'blur',
          },
        ],

        price: [
          {
            required: true,
            message: this.$i18n.t('REQUIRED_FIELD', {
              type: this.$i18n.t('PRICE'),
            }),
            trigger: 'blur',
          },
        ],
        company_vehicle: [
          {
            required: true,
            message: this.$i18n.t('REQUIRED_CHOOSE', {
              type: this.$i18n.t('VEHICLE_TITLE'),
            }),
            trigger: 'blur',
          },
        ],

        odometer: [
          {
            required: true,
            message: this.$i18n.t('REQUIRED_FIELD', {
              type: this.$i18n.t('DISTANCE_TRAVEL'),
            }),
            trigger: 'blur',
          },
        ],
        date: [
          {
            required: true,
            message: this.$i18n.t('REQUIRED_FIELD', {
              type: this.$i18n.t('DATE'),
            }),
            trigger: 'blur',
          },
        ],
        meter_interval: [{ validator: validateMeterInterval, trigger: 'blur' }],
        meter_threshold: [
          { validator: validateMeterThreshold, trigger: 'blur' },
        ],
        day_interval: [{ validator: validateDayInterval, trigger: 'blur' }],
        day_threshold: [{ validator: validateDayThreshold, trigger: 'blur' }],
      },
    }
  },
  watch: {
    service(val) {
      this.$set(this.ruleForms, 0, {
        ...val,
        attachments: val.attachments || [],
        newAttachmentTitle: '',
        selectedFile: null,
        uploadingAttachment: false,
      })
      this.addable = false
    },
  },
  methods: {
    validateFields(field) {
      // Validate field pairs to clear errors when both are filled
      if (field === 'meter_interval' || field === 'meter_threshold') {
        this.$refs.ruleForm.validateField('meter_interval')
        this.$refs.ruleForm.validateField('meter_threshold')
      } else if (field === 'day_interval' || field === 'day_threshold') {
        this.$refs.ruleForm.validateField('day_interval')
        this.$refs.ruleForm.validateField('day_threshold')
      }
    },
    formatMeterInput(value) {
      const englishValue = this.toEnglish(value, false)
      return this.currency(englishValue)
    },
    formatOdometerInput(value) {
      const englishValue = this.toEnglish(value, false)
      return this.currency(englishValue)
    },
    addEntry() {
      const newEntry = {
        price: '',
        service: '',
        company_vehicle: this.ruleForms[0].company_vehicle,
        date: this.ruleForms[0].date,
        disabled: false,
        approvers: [],
        meter_threshold: null,
        day_threshold: 7,
        meter_interval: null,
        day_interval: 30,
        odometer: this.ruleForms[0].odometer,
        attachments: [],
        newAttachmentTitle: '',
        selectedFile: null,
        uploadingAttachment: false,
      }
      this.ruleForms.push(newEntry)
    },
    removeEntry() {
      if (this.ruleForms.length > 1) {
        this.ruleForms.pop()
      }
    },
    handleOnSelectVehcile(val, index) {
      this.ruleForms[index].company_vehicle = val
      getACar.api(val).then((res) => {
        if (res && res.total_odometer) {
          this.ruleForms[index].odometer = this.currency(
            res.total_odometer / 1000
          )
        } else {
          this.ruleForms[index].odometer = 0
        }
      })
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const addActionPayload = this.ruleForms.map((formEntry) => {
            // Extract only the service-related fields, excluding attachment fields
            const {
              attachments,
              newAttachmentTitle,
              selectedFile,
              uploadingAttachment,
              ...serviceData
            } = formEntry

            return {
              ...serviceData,
              approvers: formEntry.approvers,
              price: formEntry.price
                ? +this.reverseCurrency(formEntry.price)
                : null,
              date: this.ruleForms[0].date
                ? this.jalaliToGregorian(
                    this.ruleForms[0].date,
                    this.$i18n.locale
                  )
                : null,
              company_vehicle: this.ruleForms[0].company_vehicle,
              odometer:
                this.ruleForms[0].odometer == 0
                  ? null
                  : +this.reverseCurrency(this.ruleForms[0].odometer) * 1000,
              meter_interval:
                formEntry.meter_interval == 0 || !formEntry.meter_interval
                  ? null
                  : +this.reverseCurrency(formEntry.meter_interval) * 1000,
              meter_threshold: !formEntry.meter_threshold
                ? null
                : +this.reverseCurrency(formEntry.meter_threshold) * 1000,
            }
          })

          // Extract only the service-related fields for edit payload, excluding attachment fields
          const {
            attachments,
            newAttachmentTitle,
            selectedFile,
            uploadingAttachment,
            ...editServiceData
          } = this.ruleForms[0]

          const editPayload = {
            ...editServiceData,
            approvers: this.ruleForms[0].approvers,
            price: this.ruleForms[0].price
              ? +this.reverseCurrency(this.ruleForms[0].price)
              : null,
            date: this.ruleForms[0].date
              ? this.jalaliToGregorian(
                  this.ruleForms[0].date,
                  this.$i18n.locale
                )
              : null,
            company_vehicle: this.ruleForms[0].company_vehicle,
            odometer:
              this.ruleForms[0].odometer == 0
                ? null
                : +this.reverseCurrency(this.ruleForms[0].odometer) * 1000,
            id: this.service ? this.service.id : '',
            meter_interval:
              this.ruleForms[0].meter_interval == 0 ||
              !this.ruleForms[0].meter_interval
                ? null
                : +this.reverseCurrency(this.ruleForms[0].meter_interval) *
                  1000,
            meter_threshold: !this.ruleForms[0].meter_threshold
              ? null
              : +this.reverseCurrency(this.ruleForms[0].meter_threshold) * 1000,
          }

          const payload = this.service ? editPayload : addActionPayload

          var dispatchFunc = this.service == null ? addService : editService
          this.submitLoading = true
          dispatchFunc.api(payload).then(async (res) => {
            this.submitLoading = false
            if (res) {
              // Upload attachments if any
              if (this.service) {
                // Edit mode - upload attachments for the existing service
                for (let i = 0; i < this.ruleForms.length; i++) {
                  if (
                    (this.ruleForms[i].attachments &&
                      this.ruleForms[i].attachments.length > 0) ||
                    (this.ruleForms[i].newAttachmentTitle &&
                      this.ruleForms[i].selectedFile)
                  ) {
                    await this.uploadAttachments(this.service.id, i)
                  }
                }
              } else {
                // Add mode - upload attachments for each created service
                if (Array.isArray(res)) {
                  // Multiple services created
                  for (let i = 0; i < res.length; i++) {
                    if (
                      (this.ruleForms[i].attachments &&
                        this.ruleForms[i].attachments.length > 0) ||
                      (this.ruleForms[i].newAttachmentTitle &&
                        this.ruleForms[i].selectedFile)
                    ) {
                      await this.uploadAttachments(res[i].id, i)
                    }
                  }
                } else {
                  // Single service created
                  if (
                    (this.ruleForms[0].attachments &&
                      this.ruleForms[0].attachments.length > 0) ||
                    (this.ruleForms[0].newAttachmentTitle &&
                      this.ruleForms[0].selectedFile)
                  ) {
                    await this.uploadAttachments(res.id, 0)
                  }
                }
              }

              this.$notify.success({
                title:
                  this.$t(this.$route.name) +
                  ' ' +
                  this.$t('SUCCESSFULLY_DONE'),
                duration: 5000,
                customClass: 'succ_msg',
              })
              if (this.service == null)
                this.ruleForms = [
                  {
                    approvers: [],
                    price: '',
                    service: '',
                    company_vehicle: '',
                    date: '',
                    disabled: false,
                    meter_threshold: null,
                    day_threshold: 7,
                    meter_interval: null,
                    day_interval: 30,
                    odometer: 0,
                    attachments: [],
                    newAttachmentTitle: '',
                    selectedFile: null,
                    uploadingAttachment: false,
                  },
                ]
              else
                this.$router.push({
                  name: 'VEHICLE_SERVICE_LIST',
                })
            }
          })
        } else {
          this.$notify.error({
            title: this.$i18n.t('FIXED_ERRORS', {
              type: this.$i18n.t(this.$route.name),
            }),
            duration: 5000,
            customClass: 'error_msg',
          })
          return false
        }
      })
    },
    handleFileInputChange(event, serviceIndex) {
      const file = event.target.files[0]
      if (file) {
        this.ruleForms[serviceIndex].selectedFile = file
      }
    },
    clearFile(serviceIndex) {
      this.ruleForms[serviceIndex].selectedFile = null
      // Reset the file input
      const fileInput = document.getElementById(`file-input-${serviceIndex}`)
      if (fileInput) {
        fileInput.value = ''
      }
    },
    addAttachment(serviceIndex) {
      const formEntry = this.ruleForms[serviceIndex]
      if (!formEntry.newAttachmentTitle || !formEntry.selectedFile) {
        this.$message.warning('لطفاً عنوان و فایل را وارد کنید')
        return
      }

      const newAttachment = {
        title: formEntry.newAttachmentTitle,
        file: formEntry.selectedFile,
        id: null, // Will be set after upload
        tempId: Date.now(), // Temporary ID for UI
      }

      formEntry.attachments.push(newAttachment)

      // Reset form
      formEntry.newAttachmentTitle = ''
      formEntry.selectedFile = null
      // Reset the file input
      const fileInput = document.getElementById(`file-input-${serviceIndex}`)
      if (fileInput) {
        fileInput.value = ''
      }
    },
    async removeAttachment(attachmentIndex, serviceIndex) {
      const attachment =
        this.ruleForms[serviceIndex].attachments[attachmentIndex]

      // Show confirmation dialog
      try {
        await this.$confirm(
          'آیا مطمئن هستید که می‌خواهید این پیوست را حذف کنید؟',
          'تأیید حذف',
          {
            confirmButtonText: 'حذف',
            cancelButtonText: 'لغو',
            type: 'info',
            hideIcon: true,
            class: 'sadaf',
          }
        )
      } catch (error) {
        // User cancelled the deletion
        return
      }

      if (attachment && attachment.id) {
        try {
          await axiosFactory().auth.delete(`attachments/${attachment.id}/`)
          this.$message.success('پیوست با موفقیت حذف شد')
        } catch (error) {
          console.error('Delete attachment error:', error)
          this.$message.error('خطا در حذف پیوست')
          return // Don't remove from UI if server deletion failed
        }
      }

      // Remove from the form using Vue reactive method
      const updatedAttachments = [...this.ruleForms[serviceIndex].attachments]
      updatedAttachments.splice(attachmentIndex, 1)
      this.$set(this.ruleForms[serviceIndex], 'attachments', updatedAttachments)
    },
    async downloadAttachment(attachmentId) {
      if (!attachmentId) {
        this.$message.error('شناسه پیوست یافت نشد')
        return
      }

      // Set loading state for this specific attachment
      this.$set(this.downloadingAttachments, attachmentId, true)

      try {
        const response = await axiosFactory({ type: 'blob' }).auth.get(
          `attachments/${attachmentId}/`
        )

        // Get the filename from the response headers or use a default
        const contentDisposition = response.headers['content-disposition']
        let filename = 'attachment'
        if (contentDisposition) {
          const filenameMatch = contentDisposition.match(/filename="(.+)"/)
          if (filenameMatch) {
            filename = filenameMatch[1]
          }
        }

        // Create blob and download
        const blob = new Blob([response.data])
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = filename
        document.body.appendChild(a)
        a.click()
        window.URL.revokeObjectURL(url)
        document.body.removeChild(a)

        this.$message.success('پیوست با موفقیت دانلود شد')
      } catch (error) {
        console.error('Download error:', error)
        this.$message.error('خطا در دانلود پیوست')
      } finally {
        // Clear loading state for this specific attachment
        this.$set(this.downloadingAttachments, attachmentId, false)
      }
    },
    async uploadAttachments(serviceId, serviceIndex) {
      const formEntry = this.ruleForms[serviceIndex]

      // Get existing attachments that haven't been uploaded yet
      const existingAttachments = formEntry.attachments.filter((att) => !att.id)

      // Check if there are pending attachments in the form fields
      const hasPendingAttachment =
        formEntry.newAttachmentTitle && formEntry.selectedFile

      // Create pending attachment if it exists
      if (hasPendingAttachment) {
        const pendingAttachment = {
          title: formEntry.newAttachmentTitle,
          file: formEntry.selectedFile,
          id: null,
          tempId: Date.now(),
        }
        existingAttachments.push(pendingAttachment)
      }

      // Upload all attachments
      for (const attachment of existingAttachments) {
        try {
          const formData = new FormData()
          formData.append('content_type', 'companyvehicleservice')
          formData.append('title', attachment.title)
          formData.append('object_id', serviceId)
          formData.append('file', attachment.file)

          const response = await axiosFactory().auth.post(
            'attachments/',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            }
          )

          // Update the attachment with the real ID
          const attachmentIndex = this.ruleForms[
            serviceIndex
          ].attachments.findIndex((att) => att.tempId === attachment.tempId)

          if (attachmentIndex !== -1) {
            // Update existing attachment
            this.$set(
              this.ruleForms[serviceIndex].attachments,
              attachmentIndex,
              {
                ...attachment,
                id: response.data.id,
              }
            )
          } else if (attachment.tempId && hasPendingAttachment) {
            // Add new attachment to the attachments array
            this.ruleForms[serviceIndex].attachments.push({
              ...attachment,
              id: response.data.id,
            })
          }
        } catch (error) {
          console.error('Upload error:', error)
          this.$message.error(`خطا در آپلود پیوست: ${attachment.title}`)
        }
      }
    },
  },
  created() {
    this.serviceLoading = true
    this.serviceTypeLoading = true
    this.carsLoading = true
    carsListSummary.api().then((res) => {
      if (res) {
        this.list = res
        this.carsLoading = false
      }
    })
    serviceNameList.api().then((res) => {
      if (res) {
        this.serviceList = res
        this.serviceLoading = false
      }
    })
    usersListSummary.api().then((res) => {
      if (res) {
        this.userList = res.map((i) => {
          return {
            value: i.id,
            label: i.username,
          }
        })

        this.usersListLoading = false
      }
    })
  },
}
</script>
<style>
.border-0 {
  border: 0 !important;
}
.service__container
  > div:not(.form-confirmation):not(:last-child):not(:first-child) {
  border-top: 1px solid #dddfe7;
  padding-top: 3em;
  margin: 1.5em 0;
}

/* Custom File Upload Styles */
.file-upload-container {
  width: 100%;
}

.file-upload-label {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0px 16px;
  background-color: #409eff;
  color: white;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.3s;
  font-size: 14px;
  min-height: 40px;
  border: 1px solid #409eff;
}

.file-upload-label:hover {
  background-color: #66b1ff;
}

.file-upload-label i {
  margin-right: 8px;
  font-size: 16px;
}

.file-info {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 8px;
  padding: 8px 12px;
  background-color: #f5f7fa;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}

.file-name {
  flex: 1;
  font-size: 14px;
  color: #606266;
  word-break: break-all;
}

.remove-file-btn {
  margin-left: 8px;
  padding: 4px 8px;
}
</style>
